module.exports = __webpack_public_path__ + "static/media/ST4-BG1.21dbea48.jpg";